export default class HeaderLarge {
	constructor(config) {
		this.el = config.el || document.querySelectorAll(".header__large");
		this.headerSimple = document.querySelector(".header--simple");
		this.headerSearchContainer = this.el.querySelector(".header__search");
		this.searchToggle = this.el.querySelector(
			".header__search-icon-toggle"
		);
		this.isOpen = false;
		this.searchInput = this.el.querySelector(".header__search-input");
		if (!this.headerSimple) {
			this.init();
		}
	}
	init() {
		this.attachEvents();
	}
	attachEvents() {
		const self = this;
		this.searchToggle.addEventListener("click", function(e) {
			self.toggle();
		});
		this.searchToggle.addEventListener("keyup", function(e) {
			const key = e.which || e.keyCode;
			if (key == utilities.keys.enter) {
				self.toggle();
			}
		});
		this.searchInput.addEventListener("keyup", function(e) {
			const key = e.which || e.keyCode;
			if (utilities.keys.escape == key) {
				self.close();
				self.searchToggle.focus();
			}
		});
		this.headerSearchContainer.addEventListener("focusout", function(e) {
			// blur when tabbing out
			if (self.headerSearchContainer.contains(e.relatedTarget)) {
				// don't react to this
				return;
			}
			self.close();
		});
	}
	toggle() {
		if (this.isOpen) {
			this.search();
		} else {
			this.open();
		}
	}
	open() {
		this.el.classList.add("header__search--show");
		this.searchInput.focus();
		this.isOpen = true;

		utilities.setAriaProp(
			this.searchToggle,
			"label",
			this.searchToggle.dataset.closelabel
		);
		utilities.setAriaProp(this.searchToggle, "expanded", "true");
		utilities.setAriaProp(this.searchInput, "hidden", "false");
		this.searchInput.tabIndex = 0;
	}
	close() {
		this.el.classList.remove("header__search--show");
		this.isOpen = false;
		utilities.setAriaProp(this.searchToggle, "expanded", "false");
		utilities.setAriaProp(this.searchInput, "hidden", "true");
		this.searchInput.tabIndex = -1;
	}
	search() {
		const event = new KeyboardEvent("keydown", {
			key: "Enter",
			code: "Enter",
			which: 13,
			keyCode: 13
		});

		this.searchInput.dispatchEvent(event);
	}
}
